import React from 'react';
import get from 'lodash/get';
import PropTypes from 'prop-types';
import Row from '../../../core/layout/Row';
import Button from '../../../core/form/Button';
import Column from '../../../core/layout/Column';
import TextInput from '../../../core/form/TextInput';
import FetchSelect from '../../../core/form/FetchSelect';

const ContractListFilter = (props) => (
  <Row>
    <Column size={1}>
      <TextInput
        floatingLabel
        fullWidth
        label="Document Number"
        value={get(props.values, 'documentNumber', '')}
        onChange={(value) => props.onChange('documentNumber', value)}
      />
    </Column>
    <Column size={3}>
      <TextInput
        floatingLabel
        fullWidth
        label="Social Reason"
        value={get(props.values, 'socialReason', '')}
        onChange={(value) => props.onChange('socialReason', value)}
      />
    </Column>
    <Column size={2}>
      <FetchSelect
        showSearch
        url="/companies"
        isPaginated={true}
        label="Company"
        value={get(props.values, 'company')}
        onChange={(value) => props.onChange('company', value)}
        resultTransformer={{
          text: 'name',
          value: 'id',
        }}
      />
    </Column>
    <Column size={2}>
      <FetchSelect
        showSearch
        url="/segments"
        label="Segment"
        value={get(props.values, 'segment')}
        onChange={(segment) => props.onChange('segment', segment)}
        resultTransformer={{
          text: 'name',
          value: 'id',
        }}
      />
    </Column>
    <Column size={3}>
      <FetchSelect
        showSearch
        url="/distributors"
        label="Distributor"
        value={get(props.values, 'distributor')}
        onChange={(value) => props.onChange('distributor', value)}
        resultTransformer={{
          text: 'name',
          value: 'id',
        }}
        errorText={get(props.errors, 'distributor', null)}
      />
    </Column>
    <Column size={1}>
      <div style={{ height: 42 }} />
      <Button label="Search" icon="search" onClick={props.onSearch} />
    </Column>
  </Row>
);

ContractListFilter.propTypes = {
  onChange: PropTypes.func.isRequired,
  onSearch: PropTypes.func.isRequired,
  values: PropTypes.object.isRequired,
};

export default ContractListFilter;
